const BASE_URL = 'https://server.hypehop.co.kr';

export default BASE_URL;
